export default __webpack_public_path__ + "static/media/kan11.7e792b0f.svg";